import React, { useState } from 'react';

const PassphraseSetup = ({ onSuccess, onError }) => {
  const [passphrase, setPassphrase] = useState('');
  const [confirmPassphrase, setConfirmPassphrase] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [showPassphrase, setShowPassphrase] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!passphrase.trim()) {
      setMessage({ type: 'error', text: 'Please enter a passphrase' });
      return;
    }

    if (passphrase.length < 8) {
      setMessage({ type: 'error', text: 'Passphrase must be at least 8 characters' });
      return;
    }

    if (passphrase !== confirmPassphrase) {
      setMessage({ type: 'error', text: 'Passphrases do not match' });
      return;
    }

    setLoading(true);
    setMessage(null);

    try {
      if (onSuccess) {
        const result = await onSuccess(passphrase);
        if (result?.success) {
          setMessage({ type: 'success', text: 'Passphrase set successfully!' });
          // Parent will handle next steps
        } else {
          setMessage({ type: 'error', text: result?.error || 'Failed to set passphrase' });
        }
      }
    } catch (err) {
      console.error('Error setting passphrase:', err);
      setMessage({ type: 'error', text: err.message || 'Failed to set passphrase' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="passphrase-setup-container" style={{ padding: '20px', maxWidth: '400px', margin: '0 auto' }}>
      <h2 style={{ marginBottom: '20px', color: '#fff' }}>Set Your Passphrase</h2>
      
      <p style={{ color: '#999', fontSize: '14px', marginBottom: '20px' }}>
        Your passphrase encrypts your wallet keys. You'll need it to unlock your wallet on new devices.
        This device will remember your passphrase for future sessions.
      </p>

      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', color: '#fff', marginBottom: '8px', fontSize: '14px' }}>
            Passphrase
          </label>
          <div style={{ position: 'relative' }}>
            <input
              type={showPassphrase ? 'text' : 'password'}
              placeholder="Enter passphrase (min 8 characters)"
              value={passphrase}
              onChange={(e) => setPassphrase(e.target.value)}
              disabled={loading}
              style={{
                width: '100%',
                padding: '12px 40px 12px 12px',
                borderRadius: '8px',
                border: '1px solid #333',
                backgroundColor: '#1a1a1a',
                color: '#fff',
                fontSize: '14px',
              }}
            />
            <button
              type="button"
              onClick={() => setShowPassphrase(!showPassphrase)}
              style={{
                position: 'absolute',
                right: '10px',
                top: '50%',
                transform: 'translateY(-50%)',
                background: 'none',
                border: 'none',
                color: '#999',
                cursor: 'pointer',
                fontSize: '14px',
              }}
            >
              {showPassphrase ? 'Hide' : 'Show'}
            </button>
          </div>
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', color: '#fff', marginBottom: '8px', fontSize: '14px' }}>
            Confirm Passphrase
          </label>
          <input
            type={showPassphrase ? 'text' : 'password'}
            placeholder="Confirm passphrase"
            value={confirmPassphrase}
            onChange={(e) => setConfirmPassphrase(e.target.value)}
            disabled={loading}
            style={{
              width: '100%',
              padding: '12px',
              borderRadius: '8px',
              border: '1px solid #333',
              backgroundColor: '#1a1a1a',
              color: '#fff',
              fontSize: '14px',
            }}
          />
        </div>

        {message && (
          <div
            style={{
              padding: '10px',
              borderRadius: '6px',
              marginBottom: '15px',
              backgroundColor: message.type === 'error' ? 'rgba(255, 0, 0, 0.1)' : 'rgba(0, 255, 0, 0.1)',
              color: message.type === 'error' ? '#ff4444' : '#44ff44',
              fontSize: '14px',
            }}
          >
            {message.text}
          </div>
        )}

        <div style={{ marginBottom: '15px', padding: '12px', backgroundColor: 'rgba(255, 193, 7, 0.1)', borderRadius: '6px' }}>
          <p style={{ color: '#ffc107', fontSize: '12px', margin: 0 }}>
            ⚠️ <strong>Important:</strong> Remember your passphrase! You'll need it to access your wallet on new devices.
            We cannot recover it for you.
          </p>
        </div>

        <button
          type="submit"
          disabled={loading || !passphrase || !confirmPassphrase || passphrase !== confirmPassphrase}
          style={{
            width: '100%',
            padding: '12px',
            borderRadius: '8px',
            border: 'none',
            backgroundColor: '#6366f1',
            color: '#fff',
            fontSize: '16px',
            fontWeight: '600',
            cursor: loading || !passphrase || !confirmPassphrase || passphrase !== confirmPassphrase ? 'not-allowed' : 'pointer',
            opacity: loading || !passphrase || !confirmPassphrase || passphrase !== confirmPassphrase ? 0.6 : 1,
          }}
        >
          {loading ? 'Setting up...' : 'Set Passphrase'}
        </button>
      </form>
    </div>
  );
};

export default PassphraseSetup;
